import type { RedemptionCode } from 'types'
import api from 'lib/api'

export function fetchOneByCode(code: string) {
  return api
    .get<{ data: RedemptionCode }>(`/api/v2/redemption-codes/${code}`)
    .then(({ data }) => data.data)
}
